import { IconActionButton } from "./AdminActions";

export function EmptyState({ title, text, actionLabel, onAction }: { title: string; text: string; actionLabel?: string; onAction?: () => void }) {
  return (
    <div className="empty-state">
      <div className="empty-mark">○</div>
      <h3>{title}</h3>
      <p>{text}</p>
      {actionLabel && onAction && <IconActionButton className="empty-action" label={actionLabel} icon="add" tone="primary" onClick={onAction} />}
    </div>
  );
}
